import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { ContextAPI } from "../../../ContextAPI";
import {
  Button,
  Input,
  Typography,
  Dropdown,
  Tooltip,
  Row,
  Menu,
  Col,
  Icon,
  message,
  Divider,
} from "antd";
import {
  LeftOutlined
} from '@ant-design/icons';
import "./index.less"
import { platformApi } from "../../../api";
import PMCTable from "./PMCTable";
import WrappedPMCForm from "./PMCForm";
const { Search } = Input;
const { Title } = Typography;
const { Item } = Menu;

const PMC = (props) => {
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [dataSource, setdataSource] = useState([]);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const [loggedIn, setLoggedIn] = useState("");
  const [filter, setFilter] = useState([]);
  const [PMCForm, setPMCForm] = useState(false)
  const [editable, setEditable] = useState(false)
  const [editableData, setEditableData] = useState({})
  // const [modify, setModify] = useState(false)
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    //setPrimaryData();
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "pmc") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
        }
      });
  }, []);

  useEffect(() => {
    setPrimaryData(search);
  }, [page, limit, search]);

  const setPrimaryData = (string, val) => {
    setSpinning(true);
    platformApi
      .post("/api/pmc/get", {
        page: val ? val : page,
        size: limit,
        branch: loginCredintials.branch.id,
        searchString: string,
      })
      .then((res) => {
        setSpinning(false);
        const { data } = res;
        if (data.code === 200) {
          // console.log("GET PMC", data.response.data)
          setdataSource(data.response.data.pmc);
          // setLoggedIn(data.response.data.user);
          // message.success(data.response.msg)
          setCount(data.response.data.count);
        }
      })
      .catch((err) => {
        setSpinning(false);
        console.error("PMC Fetch Error: ", err);
        message.error("Couldn't Fetch PMC");
      });
  };



  const getPMC = () => {
    setSpinning(true);
    platformApi.get("/api/pmc/").then((res) => {
      setSpinning(false)
      const { data } = res;
      if (data.code === 200) {
        // console.log("GET PMC", data)
        setSpinning(false);
        setdataSource(data.response.data);
        setLoggedIn(data.response.data.user);
        setEditable(false)
        setCount(data.response.data.length);
      }
    }).catch((err) => {
      setSpinning(false);
      console.error("PMC Fetch Error: ", err);
      message.error("Couldn't Fetch PMCs");
    });
  }
  const addPMC = (data) => {
    // console.log("Submit data", data)
    if (data.id) {
      platformApi.put("/api/pmc/" + data.id, data).then(result => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            message.success("PMC Modified Successfully")
            setPrimaryData();
          }
        }
      }).catch((err) => {
        setSpinning(false)
        console.error("PMC Add Error: ", err);
        message.error("Couldn't Add PMC");
      });
    }
    else {
      platformApi.post("/api/pmc/", data).then(result => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            message.success("PMC Added Successfully")
            setPrimaryData();
            // setPrimaryData(null, 1)
          }
          else {
            setSpinning(false)
            message.error("Couldn't Add PMC");
          }
        } else {
          setSpinning(false)
          message.error("Couldn't Add PMC");
        }
      }).catch((err) => {
        setSpinning(false)
        console.error("PMC Add Error: ", err);
        message.error("Couldn't Add PMC");
      });
    }
  }

  const deleteData = (id) => {
    setSpinning(true);
    let temp = page != 1 && dataSource.length === 1
    // if (page != 1 && dataSource.length === 1) {
    //   setPage(page - 1)
    // }
    platformApi.delete("/api/pmc/" + id).then(result => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          message.success("PMC Deleted Successfully")
          if (temp) {
            setPage(1)
            setPrimaryData(null, 1)
            // getPMC();
          }
          else {
            setPrimaryData()
            // getPMC()
          }
        }
        else {
          setSpinning(false)
          message.error("Couldn't Remove PMC");
        }
      }
      else {
        setSpinning(false)
        message.error("Couldn't Remove PMC");
      }
    }).catch((err) => {
      setSpinning(false)
      console.error("PMC Add Error: ", err);
      message.error("Couldn't Add PMC");
    });
  }

  const getMenu = () => {
    let size = count / 10 + (count % 10) ? 1 : 0;
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu), setPage(1) }} key={menu}>
        {menu}
      </Item>
    ));
  };
  const menu = <Menu>{getMenu()}</Menu>;

  return (
    <div>
      <div className="pmc-head">
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          Periodic Maintanance Chart [{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>

        <WrappedPMCForm
          visible={PMCForm}
          dataSource={dataSource}
          setDataSource={setdataSource}
          setVisible={setPMCForm}
          emitData={addPMC}
          editableData={editableData}
          editable={editable}
          setEditable={setEditable}
          setEditableData={setEditableData}
          modifyAccess={modifyAccess}
        // getPMC={getPMC}
        />
        <Search
          placeholder="Search PMC"
          className="searchbar-div-manufacturer"
          style={{ width: "30%" }}
          onSearch={(event) => {
            setPage(1)
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null)
              setPage(1)
            }
          }}
        />
        <Button
          type="primary"
          className="add-pmc-button"
          // disabled={!createAccess}
          style={{ margin: "0 3%", width: "20%" }}
          onClick={() => { setEditable(true); setPMCForm(true) }}
          disabled={!createAccess}
        >
          Add PMC
        </Button>

      </div>
      {/* <Divider /> */}
      <div>
        <PMCTable
          dataSource={dataSource}
          spinner={spinning}
          pagination={{
            onChange: (page) => {
              setPage(page);
            },
            pageSize: limit,
            defaultCurrent: 1,
            current: page,
            total: count,
            showQuickJumper: true,
          }}
          // modify={modify}
          deleteData={deleteData}
          setVisible={setPMCForm}
          setEditableData={setEditableData}
          setEditable={setEditable}
          deleteAccess={deleteAccess}
          modifyAccess={modifyAccess}
          
        />

      </div>
    </div>
  );
}
export default withRouter(PMC)